import InputField from '../../../../CommonComponents/InputMUI'
import React from "react";

const MapDoc = ({ close,docNameHandler,mapData,descriptionHandler ,matchingData,matchingDiv,submitMap}) => (
    <div className="background-blur-external" style={{ zIndex: '9999' }}>
        <div className='delete-popup-main' style={{ minHeight: '200px', marginTop: '10%', width: '500px' }}>
            <div className="text-end"><i onClick={() => close()} style={{ fontSize: '20px', color: "red", cursor: 'pointer' }} className="fa fa-close"></i></div>
            <div className="row">
                <div className="col-sm-6 col-xs-12 ">
                    <InputField
                        label="Document Name"
                        variant="outlined"
                        name={'docName'}
                        id={'docName'}
                        type="text"
                        onChange={e => descriptionHandler(e, 'docName')}
                        size="small"
                        value={mapData.docName}
                    />
                    {console.log(matchingDiv,'matchingDiv')}
                    <div style={{ marginBottom: '20px' }}>
                        {matchingData.length>0 &&matchingDiv===true ?
                            <ul className="designation-list" style={{  zIndex: '9999' }} >
                                {matchingData.map((data, j) => {
                                    return (
                                        <li key={j} value={data.document_id} onClick={() => docNameHandler(data, 'docName')} >{data.doc_name}</li>
                                    )
                                })}
                            </ul>
                            : ""}
                    </div>
                </div>
                <div className="col-sm-6 col-xs-12 ">
                <InputField
                                label="Description"
                                variant="outlined"
                                name={'description' }
                                id={'description' }
                                type="text"
                                onChange={e => descriptionHandler(e, 'description')}
                                size="small"
                                value={mapData.description}
                            />
                </div>

            </div>
            <div className='row text-center mt-3 mb-3'>
                <button className='cred-btn' style={{width:'100px',marginLeft:'auto',marginRight:'auto'}} onClick={()=>submitMap()}>Save</button>
            </div>
        </div>
    </div>
)
export default MapDoc